import yup from '../../../config/yup';

export const amazonSESConnectorFormValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('amazonSESConnector'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  parameterizedBy: yup.string(),
  properties: yup.object().shape({
    sender: yup.string().transform((value) => value?.trim()),
    recipients: yup
      .string()
      .required('Recipients are required')

      .transform((value) => value.trim()),
    subject: yup
      .string()
      .required('Subject is required')

      .transform((value) => value.trim()),
    attachments: yup.string().transform((value) => value?.trim()),
    body: yup
      .string()
      .required('Body is required')

      .transform((value) => value.trim()),
  }),
});
